/* eslint-disable no-underscore-dangle */
function getTheme() {
  return localStorage._getItem('cssvar-theme') || 'default';
}
function setTheme(name = 'default') {
  return localStorage._setItem('cssvar-theme', name);
}

async function themeChange(name = 'default', save) {
  const oldLinkEl = document.querySelector('head link[theme-element-link]');
  const oldLinkVar = document.querySelector('head link[theme-var-link]');
  let hrefEl = oldLinkEl.href;
  let hrefVar = oldLinkVar.href;
  hrefEl = hrefEl.replace(/element-(.*)\.css$/, `element-${name}.css`);
  hrefVar = hrefVar.replace(/var-(.*)\.css$/, `var-${name}.css`);

  const linkVar = document.createElement('link');
  const linkEl = document.createElement('link');

  linkVar.rel = 'stylesheet';
  linkVar.href = hrefVar;
  linkVar.setAttribute('theme-var-link', '');

  linkEl.rel = 'stylesheet';
  linkEl.href = hrefEl;
  linkEl.setAttribute('theme-element-link', '');
  document.head.appendChild(linkEl);
  document.head.appendChild(linkVar);

  const pro1 = new Promise((resolve, reject) => {
    linkEl.onload = resolve;
    linkEl.onerror = reject;
  });
  const pro2 = new Promise((resolve, reject) => {
    linkVar.onload = resolve;
    linkVar.onerror = reject;
  });
  try {
    await Promise.all([pro1, pro2]);
    oldLinkEl.remove();
    oldLinkVar.remove();
    if (save) {
      setTheme(name);
    }
    return true;
  } catch (e) {
    linkEl.remove();
    linkVar.remove();
    return Promise.reject();
  }
}

export default {
  getTheme,
  themeChange,
};
